import React from 'react';
import { observer }from 'mobx-react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Icon from '@components/Icon';

import COLORS from '@styles/theme/colors';

import stores from '@stores';
import * as S from './styles';

const ConfirmModal = () => {
  const {
    layoutStore: { confirmModal, setConfirmModal }
  } = stores;

  const onConfirm = () => {
    setConfirmModal(false);
    confirmModal.positiveCallback();
  };

  const onReject = () => {
    setConfirmModal(false);
    if(confirmModal?.negativeCallback) {
      confirmModal?.negativeCallback();
    }
  };

  const confirmIconsMap = {
    warning: <S.IconWrap bgcolor='rgba(253,180,4, .2)'>
      <Icon icon='warning' size={20} color={COLORS.yellow} />
    </S.IconWrap>,
    danger: <S.IconWrap bgcolor='#FFECEB'>
      <Icon icon='trash' size={20} color={COLORS.red} />
    </S.IconWrap>,
  };

  return (
    <S.StyledDialog
      maxWidth="sm"
      open={confirmModal?.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <S.CloseButton onClick={() => setConfirmModal(false)}>
        <Icon icon='close' size={14}/>
      </S.CloseButton>

      {confirmModal?.title && (
        <S.StyledDialogHead>
          {confirmIconsMap[confirmModal.type]}

          <DialogTitle id="alert-dialog-title">
            {confirmModal.title}
          </DialogTitle>
        </S.StyledDialogHead>

      )}
      {confirmModal?.description && (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {confirmModal.description}
          </DialogContentText>
        </DialogContent>
      )}
      <S.StyledDialogActions>
        <Button variant='contained' color='secondary' size='large' sx={{ minWidth: 105 }} onClick={onReject}>Abbrechen</Button>
        <Button variant='contained' size='large' sx={{ minWidth: 105 }} onClick={onConfirm}>{confirmModal?.positiveButtonText ||'Yes'}</Button>
      </S.StyledDialogActions>
    </S.StyledDialog>
  );
};

export default observer(ConfirmModal);
